import { render, staticRenderFns } from "./CorretivaDefeitos.vue?vue&type=template&id=8dcf7398&"
import script from "./CorretivaDefeitos.vue?vue&type=script&lang=js&"
export * from "./CorretivaDefeitos.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./CorretivaDefeitos.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports